app.service('subscriptionPaymentsView', function (
	lazyLoad, subscriptionWarranties, subscriptionServices, subscriptionResignForm, ajaxErrorHandler, accountSubscriptionPayments,
	subscriptionPaymentMethod, simpleToastr, subscriptionPaymentToast, overpaymentReturnModal
) {

	let $self;

	function init() {

		setElements();
		setEvents();
		loadSubscriptions();
		subscriptionPaymentToast.showFlashMessage();

		subscriptionWarranties.init();
		subscriptionServices.init();
		subscriptionResignForm.init();
	}

	function setElements() {
		$self = $('#subscription-payment-list');
	}

	function setEvents() {
		$('body')
			.on('click', '.js-subscription-page', function paginationClick() {
				const pageNumber = +$(this).data('page');
				loadSubscriptions(pageNumber);
				$.scrollTo($self, 0);
			})
			.on('click', '.js-pay-subscription-overdue-fee', function payOverdueClick() {
				const recurringPaymentId = $(this).data('recurring-payment-id');
				const singlePaymentId = $(this).data('single-payment-id');
				accountSubscriptionPayments.paySubscriptionFee(recurringPaymentId, singlePaymentId);
			})
			.on('click', '.js-refund-button', function () {
				const subscriptionRefundId = $(this).data('form-id');
				const subscriptionProductType = $(this).data('type');
				overpaymentReturnModal.load({
					id: subscriptionRefundId,
					type: subscriptionProductType
				});
			})
			.on('click', '.js-additional-options-toggle', function additionalOptionsToggleClick() {
				$(this).closest('.additional-options').toggleClass('show-more').toggleClass('show-less');
			})
			.on('click', '.js-change-payment-method', function changePaymentMethodClick(e) {
				e.preventDefault();
				const recurringPaymentId = $(this).closest('.subscription-item').data('id');
				const paymentMethod = $(this).data('payment-method');
				subscriptionPaymentMethod.changePaymentToken(recurringPaymentId, paymentMethod);
			})
			.on('click', '.js-add-payment-method', function addPaymentMethodClick(e) {
				e.preventDefault();
				const recurringPaymentId = $(this).closest('.subscription-item').data('id');
				const paymentMethod = $(this).data('payment-method');
				subscriptionPaymentMethod.changePaymentToken(recurringPaymentId, paymentMethod);
			})
			.on('click', '.js-remove-payment-method', function removePaymentMethodClick(e) {
				e.preventDefault();
				const $box = $(this).closest('.subscription-item');
				const recurringPaymentId = $box.data('id');
				const paymentMethod = $(this).data('payment-method');
				const paymentTokenId = $(this).data('payment-token-id');

				subscriptionPaymentMethod.removePaymentMethod(recurringPaymentId, paymentMethod, paymentTokenId, onComplete);

				function onComplete(result) {
					if (result.status === 'SUCCESS') {
						const headerMessageKey= 'subscription-after-delete-token-message-success-header';
						const descriptionMessageKey = $box.find('.toggle-payment-options').length === 0
							? 'subscription-after-delete-token-message-success-description'
							: 'subscription-after-delete-token-message-success-description-another-method-left';

						reloadSubscriptionDetails($box, recurringPaymentId)
							.then(() => {
								subscriptionPaymentToast.showSuccess(headerMessageKey, descriptionMessageKey);
							});
					} else {
						simpleToastr.error({
							header: 'Nie udało się wykonać tej akcji',
							message: result.messages[0] || "Nieznany błąd."
						});
					}
				}
			})
			.on('click', function (e) {
				if ($(e.target).closest(".additional-options").length === 0) {
					$(".additional-options").removeClass('show-less').addClass('show-more');
				}
			});
	}

	function loadSubscriptions(pageNumber = 0) {

		$self.addClass('loading');

		return fetchSubscriptions(pageNumber)
			.then(html => {
				if (html.trim() === "") {
					$self.text("Nie posiadasz jeszcze żadnych aktywnych subskrypcji.");
					return;
				}

				$self.html(html);
			})
			.fail((jqXHR, textStatus, errorThrown) => {
				const handleError = ajaxErrorHandler.createFailHandler('subscriptionPaymentsView.loadSubscriptions');
				handleError(jqXHR, textStatus, errorThrown);
				$self.text("Wystąpił błąd podczas ładowania listy subskrypcji.");
			})
			.always(() => {
				$self.removeClass('loading');
			});
	}

	function reloadSubscriptionDetails($box, recurringPaymentId) {
		const isWarranty = $box.find('.subscription-warranty-item').length > 0;

		if (isWarranty) {
			return subscriptionWarranties.loadSubscriptionWarrantyDetails(recurringPaymentId);
		}

		const $detailsBox = $box.find('.subscription-item-details');
		const nagId = $detailsBox.data('nag-id');
		const pluList = $detailsBox.data('plu-list');

		return subscriptionServices.loadSubscriptionServiceDetails(recurringPaymentId, nagId, pluList)
			.then(html => {
				$('.subscription-item-details', $box).html(html);
			});
	}

	function fetchSubscriptions(pageNumber) {
		let data = {
			pageNumber: pageNumber
		};
		return $.ajax({
			url: '/customer-subscription-products-list.ltr',
			data
		});
	}

	return {init};
});